import { Datagrid } from 'react-admin';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

function LoadingDataGrid({ ids, empty = 'No data to show', ...rest }) {
  if (ids === undefined) return <CircularProgress />;
  if (ids.length === 0) return <div>{empty}</div>;

  return <Datagrid {...rest} ids={ids} />;
}

LoadingDataGrid.propTypes = {
  ids: PropTypes.array,
  empty: PropTypes.node,
};

export default LoadingDataGrid;
